import { useTranslation } from 'react-i18next';
import { BizCheckBox } from '../Mini/BizCheckBox';
import { BizIcon } from '../Mini/BizIcon';
import { ModuleData } from '../../Types/containerV2';
import { isConfirmReadModuleContent } from '../../Types/containerV2/modules/confirmRead';
import { useContainerContext } from './ContainerContext';
import ModuleActionSurface from './ModuleActionSurface';
import './ConfirmReadModule.scss';

type ConfirmReadModuleProps = {
	module: ModuleData;
};

const ConfirmReadModule = ({ module }: ConfirmReadModuleProps) => {
	const { t } = useTranslation();
	const { finishModule, isModuleFinished } = useContainerContext();

	if (!isConfirmReadModuleContent(module.content)) {
		return null;
	}

	const isFinished = isModuleFinished(module.id);

	if (module.content.moduleType === 'Button') {
		const label = module.content.buttonLabel || t('CORE.CONFIRMREAD.BTNLABEL', 'Completed');

		return (
			<ModuleActionSurface
				className='biz-confirm-read-module biz-confirm-read-module--button'
				label={label}
				disabled={isFinished}
				trailingIcon={isFinished ? <BizIcon icon='CHECK' className='biz-confirm-read-module__finished-icon' /> : undefined}
			/>
		);
	}

	const checkboxLabel =
		module.content.checkboxLabel ||
		t('CORE.CONFIRMREAD.CHECKBOXLABEL', 'I confirm that I have read and understood the content above.');

	return (
		<div className='biz-module biz-confirm-read-module biz-confirm-read-module--checkbox'>
			<BizCheckBox
				value={isFinished}
				label={checkboxLabel}
				disabled={isFinished}
				onChange={(checked) => {
					if (!checked || isFinished) return;
					finishModule(module.id);
				}}
			/>
		</div>
	);
};

export default ConfirmReadModule;